import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export function CreditGrant({ user, index, onDone }) {
  const [open, setOpen] = useState(false);
  const [kind, setKind] = useState("video");
  const [amount, setAmount] = useState("1");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const unit = kind === "video" ? "credits" : kind === "voice" ? "min" : "images";
  const submit = async (sign) => {
    const n = Number(amount) * sign;
    if (!n || reason.trim().length < 3) return toast.error("Enter an amount and a reason (logged)");
    setBusy(true);
    try {
      const r = await api.post(`/admin/users/${user.user_id}/credits`, { kind, amount: n, reason: reason.trim() });
      toast.success(`${sign > 0 ? "Granted" : "Revoked"} ${Math.abs(n)} ${unit} · ${user.email} now has ${r.data.subscription?.credits?.video_credits_left ?? "?"} video credits`);
      setOpen(false); setReason(""); onDone?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };
  if (!open) return <button data-testid={`credit-grant-open-${index}`} onClick={() => setOpen(true)} className="mt-1.5 text-[10px] font-mono px-2 py-1 rounded-md border border-white/10 text-slate-500 hover:text-amber-200 hover:border-amber-500/40">Credits ±</button>;
  return (
    <div data-testid={`credit-grant-form-${index}`} className="mt-2 flex flex-wrap items-center gap-1.5 text-[10px]">
      <select data-testid={`credit-grant-kind-${index}`} value={kind} onChange={(e) => setKind(e.target.value)} className="bg-[#0A0C14] border border-white/10 rounded-md px-1.5 py-1 font-mono">
        <option value="video">video credits</option><option value="voice">voice min</option><option value="image">images</option>
      </select>
      <input data-testid={`credit-grant-amount-${index}`} type="number" min="0.5" step="0.5" value={amount} onChange={(e) => setAmount(e.target.value)} className="w-16 bg-[#0A0C14] border border-white/10 rounded-md px-1.5 py-1 font-mono" />
      <input data-testid={`credit-grant-reason-${index}`} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (required, logged)" className="w-40 bg-[#0A0C14] border border-white/10 rounded-md px-1.5 py-1" />
      <button data-testid={`credit-grant-add-${index}`} disabled={busy} onClick={() => submit(1)} className="px-2 py-1 rounded-md bg-emerald-500/20 border border-emerald-500/40 text-emerald-200">Grant</button>
      <button data-testid={`credit-grant-revoke-${index}`} disabled={busy} onClick={() => submit(-1)} className="px-2 py-1 rounded-md bg-red-500/15 border border-red-500/40 text-red-200">Revoke</button>
      <button onClick={() => setOpen(false)} className="text-slate-500 hover:text-white px-1">✕</button>
    </div>
  );
}
